;
import { environment } from '../environments/environment';
import { initializeApp, getApps } from 'firebase/app';

export function initializeFirebase() {
    if (!getApps().length) {
       initializeApp(environment.firebase);
    }
}
